import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPageLock"><Path d="M4 22V2H20V13.0631C19.2059 12.2528 18.0992 11.75 16.875 11.75C14.9391 11.75 13.2969 13.0074 12.7204 14.75H11.5V22H4Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 16H21V22H13V16H14C14 14.3431 15.3431 13 17 13C18.6569 13 20 14.3431 20 16ZM18.5 16C18.5 15.1716 17.8284 14.5 17 14.5C16.1716 14.5 15.5 15.1716 15.5 16H18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPageLock;
